/* ===========================
IMPORTS
=========================== */
import React from 'react';
import PropTypes from 'prop-types';
// IMPORT - ELEMENTS
import Loader from '../Elements/Loader';
import { IconSearch } from '../Elements/Icons';
// IMPORT - Helpers
import Helpers from '../../Helpers';

/* ===========================
CLASS
=========================== */
class ModalBundle extends React.Component {
  /* ===========================
  DEFAULT
  =========================== */
  /**
   * Main constructor of Component
   * @param {object} props
   */
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      meta: {},
      page: 1,
      limit: 10,
      search: '',
      loading: false,
    };

    this.get = this.get.bind(this);
    this.onClickNext = this.onClickNext.bind(this);
    this.onClickPrev = this.onClickPrev.bind(this);
    this.onSearchUpdate = this.onSearchUpdate.bind(this);
    this.onClickRow = this.onClickRow.bind(this);
  }

  /**
   * componentDidMount
   */
  componentDidMount() {
    this.props.updateLoadingModal(false);
    this.get();
  }

  /* ===========================
  FUNCTIONS
  =========================== */
  /**
   */
  searchTimeout = null;

  /**
   */
  get(params, callback, failback) {
    this.setState({
      loading: true,
    }, () => {
      // Make initial request
      const defaultPayload = {
        page: this.state.page,
        limit: this.state.limit,
      };

      if (this.state.search && this.state.search.length > 0) {
        defaultPayload.search = this.state.search;
      }

      ModalBundle.request(
        (params || defaultPayload),
        // callback
        (response) => {
          if (callback) {
            callback(response);
          } else if (response.bundles) {
            this.setState({
              data: response.bundles,
              meta: response.meta,
              loading: false,
            });
          }
        },
        // failback
        (error) => {
          if (failback) {
            failback(error);
          } else {
            this.setState({
              loading: false,
            });
          }
        },
      );
    });
  }

  /**
   * @param {function} callback
   * @param {function} failback
   */
  static request(params, callback, failback) {
    let query = '';
    if (params && Object.keys(params).length > 0) {
      Object.keys(params).map((key) => {
        query += `${key}=${params[key]}&`;
        return key;
      });
      query = `?${query}`;
    }

    Helpers.httpRequest(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/bundles${query}`,
      'get',
      null,
      // callback
      (response) => {
        if (callback) {
          callback(response);
        }
      },
      // failback
      (error) => {
        if (failback) {
          failback(error);
        }
      },
    );
  }

  /**
   * @param {object} payload
   * @param {function} callback
   * @param {function} failback
   */

  /**
   */
  onClickPrev() {
    this.setState((prevState) => ({
      page: prevState.page - 1,
    }), () => {
      this.get();
    });
  }

  /**
   */
  onClickNext() {
    this.setState((prevState) => ({
      page: prevState.page + 1,
    }), () => {
      this.get();
    });
  }

  /**
   * @param {Event} event
   */
  onSearchUpdate(event) {
    this.setState({
      search: event.target.value,
    }, () => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.get();
      }, 350);
    });

    event.preventDefault();
  }

  /**
   * @param {Event} event
   * @param {integer} id
   */
  onClickRow(event, item) {
    this.props.handleSubmit(true);
    let { data } = this.props;

    if (this.props.data.bundle && this.props.data.bundle.id
      && this.props.data.bundle.id === item.id) {
      data = { ...this.props.data, ...{ bundle: null } };
      this.props.handleSubmitSuccess(data);
    } else {
      data = { ...this.props.data, ...{ bundle: item } };
      this.props.handleSubmitSuccess(data);
    }

    event.preventDefault();
  }

  /* ===========================
  RENDER
  =========================== */
  /**
   * Main table render
   */
  renderTable() {
    return (
      <div className="table-responsive">
        <table className="table table-bordered table-hover">
          <thead>
            <tr>
              <th>&nbsp;</th>
              <th>Bundle Name</th>
            </tr>
          </thead>
          <tbody>
            {(this.state.loading)
              ? (<tr><td className="text-center" colSpan="2"><Loader /></td></tr>)
              : (
                <>
                  {(this.state.data.length > 0)
                    ? (this.state.data.map((row) => (
                      <tr key={`data-${row.id}`}>
                        <td>
                          {(this.props.data.bundle
                              && this.props.data.bundle.id
                              && this.props.data.bundle.id === row.id)
                            ? (<button onClick={(e) => this.onClickRow(e, row)} disabled={this.props.submitted} type="button" className="btn btn-danger btn-block">{(this.props.submitted) ? '...' : (<i className="fa fa-close" />)}</button>)
                            : (<button onClick={(e) => this.onClickRow(e, row)} disabled={this.props.submitted} type="button" className="btn btn-success btn-block">{(this.props.submitted) ? '...' : (<i className="fa fa-check" />)}</button>)}
                        </td>
                        <td>{row.name}</td>
                      </tr>
                    )))
                    : (<tr><td colSpan="2">No Results</td></tr>)}
                </>
              )}
          </tbody>
        </table>
      </div>
    );
  }

  /**
   * Main render
   */
  render() {
    return (
      <div>
        {(!this.props.loading)
          ? (
            <div>
              {(this.props.data.bundle && this.props.data.bundle.id
                ? (
                  <div className="Tables-Current">
                    <div className="btn-group" role="group">
                      <button onClick={(e) => this.onClickRow(e, this.props.data.bundle.id)} disabled={this.props.submitted || this.state.loading} type="button" className="btn btn-secondary"><i className="fa fa-close" aria-label="click-row" /></button>
                      <button disabled={this.props.submitted || this.state.loading} onClick={this.onClickPrev} type="button" className="btn btn-secondary">{this.props.data.bundle.name}</button>
                    </div>
                  </div>
                )
                : null
              )}

              <div className="Tables">
                <div className="Tables-Search">
                  <div className="form-group">
                    <input onChange={this.onSearchUpdate} disabled={this.state.loading || this.props.submitted} type="search" className="form-control" placeholder="Search" value={this.state.search} />
                    <IconSearch />
                  </div>
                </div>
              </div>

              <div className="Tables-Control">
                <div className="row">
                  <div className="col col-12">
                    <div className="Tables-Control-Pagination float-left">
                      <div className="btn-group" role="group">
                        <button disabled={this.props.submitted || this.state.loading || this.state.data.length === 0 || this.state.page === 1} type="button" onClick={this.onClickPrev} className="btn btn-info">Prev</button>
                        <button disabled={this.props.submitted || this.state.loading || this.state.data.length === 0 || ((this.state.meta.total - (this.state.page * this.state.limit)) <= 0)} type="button" onClick={this.onClickNext} className="btn btn-info">Next</button>
                      </div>
                    </div>

                    {(!this.state.loading)
                      ? (
                        <div className="Tables-Control-Showing">
                          {(this.state.meta.total)
                            ? (
                              <span className="Tables-Control-Showing-Results">
                                Showing
                                {(this.state.data.length > 0)
                                  ? (((this.state.page - 1) * this.state.limit) + 1)
                                  : 0}
                                -
                                {((this.state.data.length > 0)
                                  ? (() => {
                                    const currentPage = ((this.state.page - 1) * this.state.limit);
                                    return currentPage + this.state.data.length;
                                  })
                                  : 0)}
                                {' '}
                                of
                                {this.state.meta.total}
                              </span>
                            )
                            : null}
                        </div>
                      )
                      : null}

                  </div>
                </div>
              </div>
              <div className="Tables-Data">
                {(this.renderTable())}
              </div>
            </div>
          )
          : null}
      </div>
    );
  }
}

/* ===========================
PROPERTY TYPES
=========================== */
ModalBundle.propTypes = {
  loading: PropTypes.bool,
  submitted: PropTypes.bool,
  data: PropTypes.object,
  updateLoadingModal: PropTypes.func,
  handleSubmit: PropTypes.func,
  handleSubmitSuccess: PropTypes.func,
};

/* ===========================
EXPORT
=========================== */
export default ModalBundle;
